import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLowFat = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "lowfat",
	"data-name": "lowfat",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 12,
			cy: 12,
			r: 12.559595,
			id: "circle1"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 21.138599,
			y1: 2.8614004,
			x2: 2.8614004,
			y2: 21.138599,
			id: "line1"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "blood",
			transform: "matrix(0.8299012,0,0,0.8299012,2.0411857,2.1423947)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "plan2plate-icon",
					d: "m 20,14.5 a 8,8 0 0 1 -16,0 13.83,13.83 0 0 1 3.1,-8 C 7.38,6.12 7.67,5.76 7.96,5.42 A 27,27 0 0 1 12,1.5 c 0,0 8,6 8,13 z",
					id: "path1"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "plan2plate-icon",
					d: "m 16,14.5 c 0,2.76 -1.24,5 -4,5",
					id: "path2"
				}),
				/* @__PURE__ */ _jsx("line", {
					className: "plan2plate-icon",
					x1: 16,
					y1: 11.5,
					x2: 16,
					y2: 13.5,
					id: "line2"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgLowFat);
export default ForwardRef;
